import { connect } from 'react-redux';
import { AuthRoute } from 'react-router-auth';

import { AUTHENTICATION_STATE } from '../types/authentication';

const mapStateToProps = (state, ownProps) => {
  return {
    authenticated: state.authentication.state === AUTHENTICATION_STATE.LOGGED_IN, 
  }
}

export default connect<any, any, any, any>(mapStateToProps)(AuthRoute)



// WEBPACK FOOTER //
// ./src/components/auth-route.tsx